import React from 'react'
import { CheckSolidIcon, EDInfoIcon } from '../Icons'

interface ProgressBarProps {
  enhancedDataTotal: number
  originalTotal: number
}
export const ProgressBar: React.FC<ProgressBarProps> = ({ enhancedDataTotal, originalTotal }) => {
  const diff = originalTotal - enhancedDataTotal
  let state: 'under' | 'match' | 'over' = 'under'
  if (Math.abs(diff) < 0.01) state = 'match'
  else if (enhancedDataTotal > originalTotal) state = 'over'

  const percentage = originalTotal > 0
    ? Math.min(Math.max((enhancedDataTotal / originalTotal) * 100, 0), 100)
    : 0

  const formatMoney = (val: number) => `$${val.toFixed(2)}`

  return (
    <div className="progress-bar-container">
      <div className="progress-bar-header">
        <div className="progress-bar-col">
          <span className="progress-bar-label">Enhanced Data Total:</span>
          <span className={`progress-bar-amount progress-bar-amount--${state}`}>
            {formatMoney(enhancedDataTotal)}
          </span>
        </div>
        <div className="progress-bar-col align-right">
          <span className="progress-bar-label">Original Transaction Total:</span>
          <span className="progress-bar-amount progress-bar-amount--original">
            {formatMoney(originalTotal)}
          </span>
        </div>
      </div>

      <div className="progress-bar-progress-bg">
        <div
          className={`progress-bar-progress-fill progress-bar-progress-fill--${state}`}
          style={{ width: `${percentage}%` }}
        >
          {state === 'match' && <CheckSolidIcon />}
          {state === 'over' && <EDInfoIcon />}
        </div>
      </div>
    </div>
  )
}
